export default "__VITE_ASSET__c1642840__"